import Service from "../../services";

const accountModule = {
  namespaced: true,
  state: {
    documentTypes: [],
    filterDocumentType: [],
    orders: [],
    tests: [],
    filterOrders: [],
    orderChecked: [],
    documents: [],
    filterDocument: [],
    corporationId: null,
    corporation: null,
    documentSelected: 0,
    platforms: [],
    ordersSelected: [],
    testsSelected: [],
    documentFilter: {
      page_no: "1",
      direction: null,
      hospital: null,
      in: null,
      corporationId: null,
      otherCorporationId: null,
      dateOne: "",
      dateTwo: "",
      document_type_id: "",
      paymentStatus: null,
      noInvoice: false,
    },
    documentDetail: null,
    paymentStatuses: [],
    carts: [],
    filter: {
      page_no: "1",
      direction: null,
      hospital: null,
      in: null,
      corporationId: null,
      otherCorporationId: null,
      dateOne: "",
      dateTwo: "",
      document_type_id: "",
      paymentStatus: "",
      noInvoice: false,
    },
  },
  mutations: {
    SET_FILTER: (state, data) => {
      state.filter = data;
    },
    SET_DOCUMENT_TYPE: (state, data) => {
      state.documentTypes = data;
    },
    SET_ORDERS: (state, data) => {
      state.orders = data;
    },
    FILTER_ORDER: (state, data) => {
      state.filterOrders = data;
    },
    SET_ORDER_CHECKED: (state, data) => {
      state.orderChecked = data;
    },
    SET_FILTER_DOCUMENT_TYPES: (state, data) => {
      state.filterDocumentType = data;
    },
    SET_DOCUMENTS: (state, data) => {
      state.documents = data;
    },
    FILTER_DOCUMENT: (state, data) => {
      state.filterDocument = data;
    },
    SET_CORPORATION_ID: (state, data) => {
      state.corporationId = data;
    },
    SET_CORPORATION: (state, data) => {
      state.corporation = data;
    },
    SET_DOCUMENT_FILTER: (state, data) => {
      state.documentFilter = data;
    },
    SET_DOCUMENT_SELECTED: (state, data) => {
      state.documentSelected = data.documentId;
    },
    SET_DOCUMENT_DETAIL: (state, data) => {
      state.documentDetail = data;
    },
    SET_PLATFORMS: (state, data) => {
      state.platforms = data;
    },
    SET_PAYMENT_STATUSES: (state, data) => {
      state.paymentStatuses = data;
    },
    SET_CARTS: (state, data) => {
      state.carts = data;
    },
    SET_ORDERS_SELECTED: (state, data) => {
      state.ordersSelected = data;
    },
    SET_TESTS_SELECTED: (state, data) => {
      state.testsSelected = data;
    },
    SET_TESTS: (state, data) => {
      state.tests = data;
    },
  },
  actions: {
    setFilter({ commit }, data) {
      commit("SET_FILTER", data);
    },
    async setDocumentType({ commit }) {
      let res = await Service.account.getDocumentType();
      commit("SET_DOCUMENT_TYPE", res);
    },
    setApproveOrder({ commit }) {
      Service.account.getApproveOrder().then((res) => {
        commit("SET_ORDERS", res);
      });
    },
    filterData: (context, payload) => {
      Service.account.filterOrder(payload).then((res) => {
        context.commit("FILTER_ORDER", res);
      });
    },
    setOrderChecked: ({ commit }, orderChecked) => {
      commit("SET_ORDER_CHECKED", orderChecked);
    },
    generateIn: async ({ commit }) => {
      return await Service.account.generateIn();
    },
    generateTi: async ({ commit }) => {
      return await Service.account.generateTi();
    },
    setFilterDocumentType: ({ commit }, filters) => {
      commit("SET_FILTER_DOCUMENT_TYPES", filters);
    },
    createDocument: async ({ commit }, payload) => {
      return await Service.account.createDocument(payload);
    },
    setDocuments: ({ commit }) => {
      Service.account.getDocuments().then((res) => {
        commit("SET_DOCUMENTS", res);
      });
    },
    resetDocuments: ({ commit }) => {
      commit("SET_DOCUMENT_DETAIL", []);
    },
    setFilterDocument: async (context, payload) => {
      let res = await Service.account.filterDocument(payload);
      context.commit("FILTER_DOCUMENT", res);
    },
    setCorporationId: ({ commit }, corporationId) => {
      commit("SET_CORPORATION_ID", corporationId);
    },
    setCorporation: ({ commit }, corporation) => {
      commit("SET_CORPORATION", corporation);
    },
    setDocumentSelected: ({ commit }, payload) => {
      commit("SET_DOCUMENT_SELECTED", payload);
    },
    setDocument: async ({ commit }, id) => {
      let data = await Service.account.getDocument(id);
      commit("SET_DOCUMENT_DETAIL", data);
    },
    editDocument: async ({ commit }, payload) => {
      return await Service.account.editDocument(payload);
    },
    deleteDocument: async ({ commit }, id) => {
      return await Service.account.deleteDocument(id);
    },
    payment: async ({ commit }, payload) => {
      return await Service.account.payment(payload);
    },
    setPlatforms: async ({ commit }) => {
      let data = await Service.account.getPlatforms();
      commit("SET_PLATFORMS", data);
    },
    setPaymentStatuses: async ({ commit }) => {
      let data = await Service.account.getPaymentStatuses();
      commit("SET_PAYMENT_STATUSES", data);
    },
    createBlankForm: ({ commit }, payload) => {
      return Service.account.createBlankForm(payload);
    },
    getBlankForm: ({ commit }, id) => {
      return Service.account.getBlankForm(id);
    },
    editBlankForm: ({ commit }, data) => {
      return Service.account.editBlankForm(data.payload, data.id);
    },
    deleteBlankForm: ({ commit }, id) => {
      return Service.account.deleteBlankForm(id);
    },
    statFilter: ({ commit }, payload) => {
      return Service.account.statFilter(payload);
    },
    reportInvoiceFilter: ({ commit }, payload) => {
      return Service.account.reportInvoiceFilter(payload);
    },
    reportTestFilter: ({ commit }, payload) => {
      return Service.account.reportTestFilter(payload);
    },
    reportAnimalFilter: ({ commit }, payload) => {
      return Service.account.reportAnimalFilter(payload);
    },
    reportSpecimenFilter: ({ commit }, payload) => {
      return Service.account.reportSpecimenFilter(payload);
    },
    uploadGraphImage({ commit }, payload) {
      return Service.account.uploadGraphImage(payload);
    },
    getOrderLabInvoice({ commit }, data) {
      return Service.account.getOrderLabInvoice(
        data.hospitalId,
        data.documentId,
        data.date
      );
    },
    getOrderLabInvoiceByLN({ commit }, data) {
      return Service.account.getOrderLabInvoiceByLN(data.ln, data.documentId);
    },
    createManualLabInvoice({ commit }, data) {
      const ln = data.ln;
      delete data.ln;
      const payload = { ...data };
      return Service.account.getOrderLabInvoice(ln, payload);
    },
    updateManualLabInvoice({ commit }, data) {
      const id = data.id;
      delete data.id;
      const payload = { ...data };
      return Service.account.updateManualLabInvoice(id, payload);
    },
    updateManualLabInvoiceDetail({ commit }, data) {
      const ln = data.ln;
      delete data.ln;
      const payload = { ...data };
      return Service.account.updateManualLabInvoiceDetail(ln, payload);
    },
    deleteManualLabInvoice({ commit }, id) {
      return Service.account.deleteManualLabInvoice(id);
    },
    getLabPromotions({ commit }) {
      return Service.account.getLabPromotions();
    },
    getTestPrice({ commit }, data) {
      return Service.account.getTestPrice(data.id, data.specieId);
    },
    getSetTestPrice({ commit }, data) {
      return Service.account.getSetTestPrice(data.id, data.specieId);
    },
    getItemInvoices({ commit }, id) {
      return Service.account.getItemInvoices(id);
    },
    printDocument({ commit }, payload) {
      return Service.account.printDocument(
        payload.documentSelected,
        payload.id,
        payload.isCopy
      );
    },
    getBankAccounts({ commit }, { corporationId, corporationType }) {
      return Service.account.getBankAccounts(corporationId, corporationType);
    },
  },
  getters: {
    getDocumentType(state) {
      return state.documentTypes;
    },
    getFilterDocumentType(state) {
      return state.filterDocumentType;
    },
    getOrders(state) {
      return state.orders;
    },
    getFilterOrders(state) {
      return state.filterOrders;
    },
    getOrderChecked(state) {
      return state.orderChecked;
    },
    getDocuments(state) {
      return state.documents;
    },
    getFilterDocument(state) {
      return state.filterDocument;
    },
    getCorporationSelected(state) {
      return state.corporationId;
    },
    getCorporationObjectSelected(state) {
      return state.corporation;
    },
    getdocumentSelected(state) {
      return state.documentSelected;
    },
    getDocumentDetail(state) {
      return state.documentDetail;
    },
    getPlatforms(state) {
      return state.platforms;
    },
    getPaymentStatuses(state) {
      return state.paymentStatuses;
    },
    getTests(state) {
      return state.tests;
    },
    getFilter(state) {
      return state.filter;
    },
  },
};
export default accountModule;
